<template>
  <el-container id="MainPact">
    <!-- 停服通告 -->
    <el-dialog
      :show-close="false"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="600"
      title
      :visible.sync="pactShow"
      class="pact-dialog"
    >
      <div v-if="pacts[pactNow].name == 'normal'" class="pact-style">
        <h1>
          非常抱歉！轻芒小程序+
          不再接受新用户注册和续费。如果你有制作小程序或其他产品的需求，我们提供定制设计和研发的服务，更加灵活地满足你的个性化需求。微信添加
          hiqingmang 与我们联系（你的账号 id 是 {{ accountInfo.uid }}）。
        </h1>
      </div>
    </el-dialog>
    <!-- 弹窗 服务条款 -->
    <!-- <el-dialog
      :show-close="false"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="600"
      title
      :visible.sync="pactShow"
      class="pact-dialog"
    >
      <div v-if="pacts[pactNow].name == 'normal'" class="pact-style">
        <h1>
          轻芒内容创作者服务协议
        </h1>
        <p>
          我们一直相信：每一个认真创作的内容品牌都是独一无二的灵魂
          ，理应被充分发现和热爱。
        </p>
        <p>
          通过产品和技术能力，帮助内容创作者成就独特的品牌，是轻芒小程序+
          的设计起点，也是轻芒的使命。感谢你选择轻芒，也期待你为这个世界继续创造好内容。
        </p>
        <p>
          轻芒很高兴在这样一个匆忙的时代里遇见你。
        </p>
        <p>
          这份文本是你和北京联翩科技有限公司及其关联方（下称「轻芒」或「我们」）之间就轻芒为内容创作者提供的产品及服务（下称「轻芒服务」）订立的协议（下称「本协议」），以约定我们之间的权责。除本协议正文内容外，轻芒制定、发布的其他条款及服务准则（包括但不限于《轻芒用户服务协议》、《轻芒用户隐私保护协议》）也是本协议的有效组成部分，与本协议具有同等法律效力。
        </p>
        <p>
          你在注册过程中点击「我同意」，即表明你同意本协议。如果你不同意本协议中的条款，则不应继续使用轻芒服务。如果你代表企业或组织使用轻芒服务，则你代表该企业或组织同意本协议，并且你保证你有权这么做。
        </p>
        <h2>
          术语
        </h2>
        <p>
          如无特别说明，下列术语在本协议中的含义为：
        </p>
        <ul>
          <li>
            轻芒小程序+：轻芒为内容创作者提供的自助小程序制作和发布平台。
          </li>
          <li>
            轻芒产品：包括轻芒运营的产品及轻芒与其它合作伙伴共同运营的产品等。
          </li>
          <li>
            内容创作者：是指注册、登录、使用轻芒小程序+
            或在轻芒产品中发布内容的个人、企业或组织，在本条款中更多地称为「你」或「合作伙伴」。
          </li>
          <li
            >最终用户：是指你通过轻芒产品所发布的产品、内容、服务的使用者。</li
          >
        </ul>
        <h2>
          注册账号
        </h2>
        <ul>
          <li>
            为了使用轻芒服务，你首先需要注册一个账号。你在注册账号时，须提供真实、有效的注册信息，并应在前述资料发生变更时，及时进行更新。你注册的账号的所有权归轻芒所有，使用权仅归属于你。
          </li>
          <li>
            轻芒账号是轻芒识别你并向你提供服务的依据，你需自行确保你的账号安全性，保证他人不会对其进行使用。你不得以任何形式将轻芒账号及密码转让、赠予、出借、售卖予第三方或者以其他方式许可非初始注册人对其进行使用。总之，你需对你的账号下发生的所有活动承担完全责任。
          </li>
          <li>
            如果你发现或怀疑自己的账号遭他人非法使用，或有异常使用的情形，应立即通知我们。轻芒在核实你所提供的有效注册信息后，将尽可能为你提供必要协助。但由于网络服务的复杂性，我们并不承诺你一定能通过该途径找回你的账号。
          </li>
        </ul>
        <h2>轻芒提供的服务，和你的运营责任及合法性保证</h2>
        <ul>
          <li>
            你可通过轻芒服务自助制作小程序（下称「你的小程序」），或在轻芒产品上向最终用户发布内容。你了解并确认，轻芒仅依照本协议提供小程序相关技术服务。
            <strong
              >你是你的小程序的实际运营者并对其完全负责，而不是轻芒。</strong
            >
          </li>
          <li>
            <strong
              >你作为你的小程序的实际运营者，应严格按照相关法律法规及本协议的约定全面履行运营者的相应义务，包括但不限于履行作为《互联网用户公众账号信息服务管理规定》使用者应承担的信息发布和运营安全管理责任，并自行承担由此引发的相应法律责任，并保证轻芒就此免责。</strong
            >
          </li>
          <li>
            <strong
              >你承诺，将不会利用轻芒账号或服务进行违反我国法律、法规、相关规定和社会公序良俗的行为。</strong
            >
          </li>
          <li>
            <strong>
              你的小程序若需独立发布为微信小程序，你需自行注册微信公众平台账号，并将你的小程序提交腾讯进行发布审核。微信公众平台由腾讯管理运营，而不是轻芒。作为小程序的实际运营者，你需和腾讯订立相关协议，并遵守微信公众平台和腾讯的相关运营规则。就微信公众平台对你的小程序进行发布审核或其它管理行为的结果，包括拒绝发布，轻芒无法做出承诺，亦不承担任何责任。因微信公众平台发布审核或其它管理行为造成的损失，轻芒概不负责，亦不能退还已支付给轻芒的服务费用
              (如有)。
            </strong>
          </li>
          <li
            >你和你的小程序的最终用户订立的使用协议、隐私政策等，不应违反本协议的约定。</li
          >
          <li>
            合作期内，你可在本协议明确约定的范围内获得由轻芒提供的、包含在服务中的软件使用许可，这一许可是不可转让的、非独占性的。未经轻芒的同意，你不得将其用于轻芒书面许可外用途，如通过非公开的界面访问、修改、破解轻芒服务，进行反向工程等。
          </li>
          <li>
            你应确认，轻芒产品、品牌所包含的一切合法权利仍均归属轻芒独占性所有，本协议的签订及履行并不会导致和意味相应权利发生转移或向你授予任何额外的使用许可。除以轻芒许可的「由轻芒呈现」字样标识和告知最终用户这一小程序使用轻芒服务制作及其他轻芒明确许可的方式外，未经轻芒许可，你不得明示或暗示与轻芒存在隶属或关联关系，如明示或暗示轻芒是你的小程序的运营者和/或内容提供方。除另有约定外，你不能使用轻芒的商业标识（包括名称、logo、商标及其他品牌视觉元素等）进行宣传。
          </li>
          <li>
            轻芒会根据你选择的服务类型向你提供相应的服务，但你理解并同意，基于用户体验、运营安全、对内容价值观和品质的判断等综合因素，我们有权选择我们提供服务的对象，也有权决定功能开放、数据接口和相关数据披露的对象和范围。除另有条款约定，轻芒保留视具体情况中止或终止向包括但不限于以下情形的内容创作者提供本服务，或限制对服务任一部分的使用，而不需要事先通知的权利：1)
            违反法律法规、社会公序良俗的；2) 违反本协议其它规定的；3)
            违反轻芒内容运营规则的或轻芒其它合理管理原则的。
          </li>
        </ul>
        <h2>你的内容权利</h2>
        <ul>
          <li>你创造并在轻芒服务上发布的内容，归你所有。</li>
          <li>
            <strong
              >为保证轻芒服务的正常进行和用户体验的不断改进，当你和你的最终用户通过轻芒服务发布内容时，你同意授予轻芒非独有的、免费的、永久的、不可撤销的，在轻芒产品和全世界范围内任何媒体上使用、转载、改编、出版、翻译、创作衍生作品、分发和展示这些内容的许可。未经你的明确同意，轻芒不得另行售卖、转授权你的内容，也不得修改收费内容的定价。轻芒保证在呈现内容时明确注明出处品牌和作者，但我们可以对内容进行不影响原意的更改，如修改错别字、调整排版格式、图片尺寸等。</strong
            >
          </li>
          <li>
            轻芒可以用以下行为宣传推广轻芒服务：1)
            在你的小程序中，对轻芒的品牌进行展示；2)
            在轻芒以外的平台、网站等采取各种形式对你与轻芒合作事宜的宣传、推广；
            3) 使用你的品牌名称或品牌 LOGO 等相关标志性素材。
          </li>
          <li
            >除非另有条款约定，我们欢迎你发布在其它平台已经发布过的内容，但你需保证这不与你与其它内容平台达成的协议冲突。就此产生的纠纷，你应保证轻芒免于承担任何责任。</li
          >
          <li>
            你应确保你和你的最终用户发布的内容和信息（包括但不限于网页、文字、图片、音频、视频、图表、电子文件等）无论是否原创，已得到有关权利人的授权（包括免费、公有领域或创作共用等协议）。你应确保，你和你的最终用户有权发布这些内容并许可轻芒使用。假如就此产生纠纷，你应保证轻芒免于承担任何责任。
          </li>
          <li
            >你可以随时因任何原因要求我们删除你和你的最终用户发布的任何内容。请你理解，由于技术原因，我们可能会在你发出删除指令后有一定的时间延迟，方能真正删除这些内容。</li
          >
          <li
            >除另有约定外，轻芒无需为按照本协议享有的上述权益而支付任何费用。你同意不因轻芒的前述使用行为向轻芒主张任何形式的违约、侵权或其他索赔主张。</li
          >
        </ul>
        <h2>服务免责</h2>
        <ul>
          <li>
            我们始终会不断更改和改进轻芒服务，包括可能会增加服务功能，也可能暂停或彻底停止一些服务功能，或者进行其他形式的调整。如果轻芒停止某项服务，或者某项调整影响了你的正常使用，会向你发出合理的提前通知。但除另有条款约定，轻芒保留不经事先通知随时变更、中断或终止部分或全部的轻芒服务，包括收费服务的权利。
          </li>
          <li>
            你同意并理解，除非另有条款约定，轻芒对轻芒服务及其所涉及的技术、信息均未作任何明示或暗示的保证，包括但不限于轻芒所提供服务的及时性、安全性、适用性、没有错误或疏漏、持续性、稳定性、准确性、可靠性。除非另有条款约定，因上述事由导致的损失，轻芒无需为此承担任何责任。轻芒也无法对尚未发布的未来服务做出承诺。
          </li>
          <li>
            轻芒不担保轻芒服务，包括收费服务不会中断，尽管我们会尽可能发出合理的提前通知，轻芒保留不经事先通知为检修、维护、升级或其它目的暂停轻芒服务任何部分的权利。你同意并理解，无论是否因上述情况而造成的轻芒服务，包括收费服务的中断，除另有条款约定，轻芒无需为此承担任何责任。
          </li>
          <li>
            你可能会通过轻芒服务接入其它国际互联网站或资源的链接。由于轻芒无法控制这些网站及资源，你了解并同意，对于此类网站或资源是否可供利用，轻芒不予负责，存在或源于此类网站或资源之任何内容、广告、产品或其它资料的合法性、准确性、真实性、适用性、安全性等，轻芒亦不予保证或负责。你因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，轻芒不承担任何责任。
          </li>
          <li>
            轻芒所提供的服务中可能包括广告，你同意在使用过程中显示轻芒和第三方供应商、合作伙伴提供的广告及第三方链接。你及最终用户应自行对依据该广告信息进行的交易负责，如你及最终用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，你应保证轻芒免于承担任何责任。
          </li>
        </ul>
        <h2>个人信息保护</h2>
        <p>
          对于最终用户使用小程序所产生的行为数据，轻芒和你共同拥有使用权。合作结束后，轻芒也就此享有非排他的使用权。尽管有如上约定，轻芒保留删除相应行为数据的权利。你作为你的小程序的实际运营者，应和最终用户另行订立个人信息保护政策，并遵守相关法律法规的规定及本协议中的约定。
        </p>
        <h2>
          轻芒的管理行为
        </h2>
        <ul>
          <li>
            你理解并同意，在接到第三方权利主张或轻芒根据自身判断认为你或你的最终用户所发布内容存在侵权风险时，轻芒有权不经通知直接删除、屏蔽相应内容且不视为违约。
          </li>
          <li>
            你理解并同意，轻芒有权依独立判断对你违反有关法律法规或本协议规定的行为采取相应措施（包括但不限于采取警告、限制或禁止使用部分或全部功能、账号封禁直至注销等），并公告处理结果。你和你的最终用户应独自承担由此而产生的一切法律责任及损失（包括但不限于由此导致的用户资料、个人信息、聊天记录及相关数据等的清空或限制访问等）。
          </li>
          <li>
            你理解并同意，因你违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，你应当独立承担责任；轻芒因此遭受损失（包括但不限于赔偿金、律师费、公证费、差旅费等）的，你也应当一并赔偿。
          </li>
        </ul>
        <h2>
          适用法律及争议解决
        </h2>
        <ul>
          <li>
            你同意本协议以及你和轻芒之间发生的任何争议均适用中华人民共和国法律（不包括冲突法）。
          </li>
          <li>
            因本协议产生之争议，双方应首先协商解决；双方未能以诚意协商解决的，任何一方均应将纠纷或争议提交至北京仲裁委员会通过仲裁方式解决。仲裁裁决是终局的，对各方均有约束力。
          </li>
        </ul>
        <h2>
          其他
        </h2>
        <ul>
          <li>
            轻芒会不时修改上述条款。请你定期查阅本条款。轻芒会在网页上或程序中的显著位置公布这些条款的修改通知，并列明最近的修改日期。如轻芒对本协议做出实质调整，会尽可能向你发出提前通知。如你不同意轻芒对相应条款作出的修改，你应立即停止使用轻芒所提供的服务。
          </li>
          <li>
            如果本条款中任何一条被视为废止、无效或因任何理由不可执行，该使用条件应视为可分割的且不影响任何其余条款的有效性和可执行性。
          </li>
          <li>
            双方确认，轻芒可将本协议下的权利和义务的部分或全部转让给轻芒的关联公司或继任者，如果你不同意轻芒的该转让，则应立即停止使用本协议下服务。否则，视为你对此予以接受。
          </li>
          <li>
            如你就本协议合作内容另行签署《授权书》的，则相应授权书构成本协议的有效组成部分，如授权书内容与本协议约定不一致的，以本协议为准。
          </li>
        </ul>
        <p>
          轻芒在法律允许最大范围内对本协议拥有解释权与修改权。若你对轻芒及本服务有任何意见，欢迎联系我们。
        </p>
      </div>
      <div v-if="pacts[pactNow].name == 'complement'" class="pact-style">
        <h1>
          轻芒内容创作者服务协议 · 专业版免费试用补充条款
        </h1>
        <p>
          欢迎回来。为感谢你很早就选择了轻芒小程序+，我们决定为你免费赠送 6
          个月的轻芒小程序+
          专业版服务免费试用期，用小程序成就你的内容品牌，从参差不齐的内容里跳出来！
        </p>
        <p>
          在此期间内，你可免费试用轻芒小程序+
          专业版的全部服务功能，服务具体内容详见轻芒网站 qingmang.mobi
          内发布的专业版功能服务清单。
        </p>
        <p>
          你同时理解和认可，鉴于试用的免费性，你不得就试用期间的服务向轻芒主张任何损失或违约责任，无论这些损失是直接的或间接的。试用期结束后，如你拟继续购买轻芒小程序+
          专业版服务的，请通过点击确认《轻芒内容创作者服务协议·专业版补充协议》并完成付款，以继续使用轻芒服务。
        </p>
      </div>
      <div class="yes">
        <div class="left">
          <div v-for="(e, i) in pacts" :key="i" class="one">
            <el-checkbox v-model="e.sign">{{ e.title }}</el-checkbox>
          </div>
        </div>
        <div class="right">
          <qm-button
            :disabled="pacts[0].sign === false"
            text="同意"
            @click="bindSignPact"
          />
        </div>
      </div>
    </el-dialog> -->
  </el-container>
</template>

<script>
import * as api from 'src/api/index'
import * as qm from 'src/utils/utils'
import {mapGetters} from 'vuex'
export default {
  name: 'MainPact',
  data() {
    return {
      pactShow: false,
      pacts: [
        {
          sign: false,
          title: '我同意 轻芒内容创作者服务协议',
          name: 'normal',
        },
        // {
        //   sign: false,
        //   title: '我同意 轻芒内容创作者服务协议 · 专业版免费试用补充条款',
        //   name: 'complement',
        // },
      ],
      pactNow: 0,
      userId: 1,
    }
  },
  computed: {
    ...mapGetters({
      accountInfo: 'accountInfo',
    }),
  },
  methods: {
    // 签协议
    async bindSignPact() {
      this.pactShow = false
      let res
      res = await api.Ajax({
        url: `/ng/v1/publication.agreement.sign`,
        data: {
          type: 'console',
          version: this.pacts[0].name,
        },
      })
      if (res.ok) {
        qm.GA('account', 'agreed_terms', '')
        // 协议签署成功
        // this.pactShow = false
      }
    },
  },
  async created() {
    // 检查协议
    // let res
    // res = await api.Ajax({
    //   url: `/ng/v1/publication.agreement.check`,
    //   data: {
    //     type: 'console',
    //     version: this.pacts[0].name,
    //   },
    // })
    // // this.pactShow = true
    // if (!res.ok) {
    //   setTimeout(() => {
    //     this.pactShow = true
    //   }, 400)
    // }
  },
}
</script>

<style lang="scss">
@import '~static/css/ref';

#MainPact {
  .pact-dialog {
    .el-dialog {
      padding: 0;
    }
    .el-dialog__header {
      padding: 0;
    }
    .yes {
      border-top: 1px solid #dcdddd;
      padding: 24px 40px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        flex-direction: column;
        color: #000;

        .one {
          display: flex;
          align-items: center;

          .el-checkbox {
            margin-right: 10px;
          }

          .title {
            cursor: pointer;
          }
        }
      }

      .right {
        .qm-button {
          box-shadow: none;
        }
      }
    }
  }
  .pact-style {
    color: #595656;
    padding: 40px 40px;
    overflow-y: scroll;
    height: auto;
    h1 {
      font-size: 18px;
      color: #000;
      margin: 12px 0 24px;
    }
    h2 {
      margin: 12px 0;
      font-size: 16px;
      color: #000;
    }
    p {
      margin-bottom: 16px;
    }
    ul {
      padding-left: 16px;
    }
    ul li {
      list-style-type: disc;
      margin: 4px 0;
    }
    ul ul li {
      list-style-type: circle;
    }
    strong {
      font-weight: bold;
    }
  }
  .expired-dialog {
    .el-dialog {
      width: 400px;
      .el-dialog__header {
        padding: 0;
      }
      .el-dialog__body {
        display: flex;
        flex-direction: column;
        padding: 0 24px 16px;
        color: #333;
      }
    }
    .title {
      text-align: center;
      font-weight: bold;
      padding: 16px;
      font-size: 18px;
    }
    .subtitle {
      font-weight: 400;
      line-height: 20px;
    }
    .text-btn {
      cursor: pointer;
      color: #0094ee;
      margin-top: 8px;
    }
    .btn {
      align-self: flex-end;
    }
  }
}
</style>
